var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unauthorized)?_c('v-alert',{staticClass:"mt-3",attrs:{"border":"top","color":"red","dark":""}},[_vm._v(_vm._s(_vm.tLocal("unauthorized")))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }